export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11044.1dcb90f5.jpg";